export const PASSWORD = 'password'
export const TEXT = 'text'

export const PRIVACY_POLICY_URL = 'https://static.qiibee.com/qbx/qiibee-Privacy-Website.pdf'
export const TERMS_AND_CONDITIONS_URL = 'https://static.qiibee.com/qbx/qiibee-Terms-Wallet.pdf'


// WEBPACK FOOTER //
// ./src/constants/constants.js